<template>
  <div class="custom-date-picker">
    <div class="custom-date-picker-panel">
      <i
        class="left-btn"
        :class="{
          'available-btn':
            pickedYear > currentYear ||
            (pickedYear == currentYear && pickedMonth > currentMonth),
        }"
        @click="PrevMonth"
      ></i>
      <div class="current-date" @click="GoPickDate($event)">
        <span class="current-date-value"
          >{{ pickedYear }}年{{ pickedMonth }}月</span
        >
        <span
          class="is-current-month"
          v-if="pickedYear === currentYear && pickedMonth === currentMonth"
          >当月</span
        >
      </div>
      <i class="right-btn" @click="NextMonth"></i>
    </div>
    <div
      class="custom-date-picker-popper"
      v-show="showPopper"
      ref="showPopper"
      @click.stop=""
    >
      <div class="year-selector">
        <i
          class="prev-year"
          :class="{ 'unable-click': pickedYear <= currentYear }"
          @click="PrevYear"
        ></i
        ><span class="year-value">{{ pickedYear }}年</span
        ><i class="next-year" @click="NextYear"></i>
      </div>
      <div class="month-selector">
        <div
          v-for="(item, index) in months"
          :key="index"
          class="month-item"
          :class="{
            'empty-attendance': !item.IsSelected,
            'current-month': item.IsCurrentMonth,
            'not-editable': IsNotEditable(item.Month, months),
            'selected-month': item.Month === pickedMonth,
          }"
          @click="PickDate(item.Month, months)"
        >
          {{ Transfer(item.Month) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomDatePicker",
  props: ["year", "month", "months"],
  watch: {
    showPopper(val) {
      if (val) {
        document.addEventListener("click", (e) => {
          this.showPopper = false;
        });
      } else {
        document.removeEventListener("click", (e) => {});
      }
    },
    year(val) {
      if (!val) return;
      this.pickedYear = val;
    },
    month(val) {
      if (!val) return;
      this.pickedMonth = val;
    },
    months(list) {
      if (!list) return;
      this.currentMonth = list.filter((i) => i.IsCurrentMonth)[0].Month;
    },
  },
  mounted() {
    this.pickedYear = this.year;
    this.pickedMonth = this.month;
  },
  beforeDestroy() {
    document.removeEventListener("click", () => {});
  },
  data() {
    return {
      pickedYear: "",
      pickedMonth: "",
      showPopper: false,
      currentYear: new Date().getFullYear(),
      currentMonth: "",
    };
  },
  methods: {
    PrevMonth() {
      let year = "";
      let month = "";
      if (
        this.pickedYear == this.currentYear &&
        this.pickedMonth <= this.currentMonth
      )
        return;
      if (this.pickedMonth == 1) {
        year = this.pickedYear - 1;
        month = 12;
      } else {
        year = this.pickedYear;
        month = this.pickedMonth - 1;
      }
      this.$emit("PickDate", { year: year, month: month });
      this.showPopper = false;
    },
    NextMonth() {
      let year = "";
      let month = "";
      if (this.pickedMonth == 12) {
        year = this.pickedYear + 1;
        month = 1;
      } else {
        year = this.pickedYear;
        month = this.pickedMonth + 1;
      }
      this.$emit("PickDate", { year: year, month: month });
      this.showPopper = false;
    },
    PrevYear() {
      if (this.pickedYear == this.currentYear) return;
      let year = this.pickedYear - 1;
      let month = this.pickedMonth;
      this.$emit("PickDate", { year: year, month: month });
      this.showPopper = false;
    },
    NextYear() {
      let year = this.pickedYear + 1;
      let month = this.pickedMonth;
      this.$emit("PickDate", { year: year, month: month });
      this.showPopper = false;
    },
    GoPickDate(e) {
      this.showPopper = !this.showPopper;
      e.stopPropagation();
    },
    PickDate(month, months) {
      if (
        this.pickedYear < this.currentYear ||
        (this.pickedYear == this.currentYear && month < this.currentMonth)
      ) {
        return;
      } else {
        this.$emit("PickDate", { year: this.pickedYear, month: month });
        this.showPopper = false;
      }
    },
    IsNotEditable(month, months) {
      if (
        this.pickedYear < this.currentYear ||
        (this.pickedYear == this.currentYear && month < this.currentMonth)
      ) {
        return true;
      } else {
        return false;
      }
    },
    Transfer(val) {
      switch (val) {
        case 1:
          return "一月";
          break;
        case 2:
          return "二月";
          break;
        case 3:
          return "三月";
          break;
        case 4:
          return "四月";
          break;
        case 5:
          return "五月";
          break;
        case 6:
          return "六月";
          break;
        case 7:
          return "七月";
          break;
        case 8:
          return "八月";
          break;
        case 9:
          return "九月";
          break;
        case 10:
          return "十月";
          break;
        case 11:
          return "十一月";
          break;
        case 12:
          return "十二月";
          break;
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.custom-date-picker {
  position: relative;
  .custom-date-picker-panel {
    display: flex;
    align-items: center;
    .left-btn {
      width: 32px;
      height: 32px;
      box-sizing: border-box;
      border: 1px solid #dcdfeb;
      border-radius: 4px 0 0 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      &::after {
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        border-top: 2px solid #c0c4cc;
        border-left: 2px solid #c0c4cc;
        transform-origin: center;
        transform: rotate(-45deg);
        margin-left: 4px;
      }
      &.available-btn:hover {
        cursor: pointer;
        &::after {
          border-top: 2px solid #4e81fa;
          border-left: 2px solid #4e81fa;
        }
      }
    }
    .right-btn {
      width: 32px;
      height: 32px;
      box-sizing: border-box;
      border: 1px solid #dcdfeb;
      border-radius: 0 4px 4px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &::after {
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        border-top: 2px solid #c0c4cc;
        border-right: 2px solid #c0c4cc;
        transform-origin: center;
        transform: rotate(45deg);
        margin-right: 4px;
      }
      &:hover {
        &::after {
          border-top: 2px solid #4e81fa;
          border-right: 2px solid #4e81fa;
        }
      }
    }
    .current-date {
      width: 194px;
      height: 32px;
      box-sizing: border-box;
      border: 1px solid #dcdfeb;
      border-left: 0;
      border-right: 0;
      display: flex;
      align-items: center;
      padding: 0 10px;
      .current-date-value {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: #303133;
      }
      .is-current-month {
        font-size: 12px;
        font-weight: 500;
        line-height: 17px;
        color: #4c80fa;
        padding: 2px 5px;
        background: #edf0fc;
        opacity: 1;
        border-radius: 4px;
        margin-left: 10px;
      }
    }
  }
  .custom-date-picker-popper {
    position: absolute;
    top: 43px;
    left: 0;
    z-index: 8;
    width: 322px;
    height: 276px;
    background: #ffffff;
    box-shadow: 0px 8px 20px rgba(48, 49, 51, 0.1);
    opacity: 1;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 0 11px;
    .year-selector {
      height: 62px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 9px;
      border-bottom: 1px solid #e6e9f5;
      .prev-year {
        width: 14px;
        height: 14px;
        background: url(../../assets/image/双左_double-left.png);
        background-size: cover;
        cursor: pointer;
        &.unable-click {
          cursor: not-allowed;
        }
      }
      .next-year {
        width: 14px;
        height: 14px;
        background: url(../../assets/image/双右_double-left.png);
        background-size: cover;
        cursor: pointer;
      }
      .year-value {
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
        color: #303133;
      }
    }
    .month-selector {
      height: 213px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      padding: 0 13px;
      .month-item {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: #303133;
        width: 60px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        position: relative;
        &.current-month {
          color: #2f68ed;
        }
        &.not-editable {
          background: #f5f7fa;
          color: #c0c4cc;
          cursor: not-allowed;
          &:hover {
            background: #f5f7fa;
          }
        }
        &.selected-month {
          background: #dcdfeb;
        }
        &.empty-attendance {
          &::after {
            content: "";
            display: inline-block;
            width: 6px;
            height: 6px;
            background: #fc4848;
            border-radius: 50%;
            opacity: 1;
            position: absolute;
            top: 7px;
            right: 3px;
          }
        }
        &:hover {
          background: #edf0fc;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CustomComponent/CustomDatePicker.vue